import * as queryString from 'query-string';

import { PlayerProfileTabIdentifiers } from './constants';
import { savedListTypes, getPlayerName } from './index';

export const getSavedPlayersMenuPath = (savedListEnabled, claimedPlayer) => {
    if (savedListEnabled && claimedPlayer?.playerId) {
        return `/players/${claimedPlayer.playerId}?t=${PlayerProfileTabIdentifiers.SAVED_LISTS}`;
    }
    return '/saved/players';
};

export const getSavedPlayersRedirectPath = (savedListEnabled, claimedPlayer, isPlayersList) => {
    if (isPlayersList && savedListEnabled && claimedPlayer?.playerId) {
        return getSavedPlayersMenuPath(savedListEnabled, claimedPlayer);
    }
    return null;
};

const DEFAULT_TITLE = 'Manage Lists';

const firstValue = (value) => (Array.isArray(value) ? value[0] : value);

const getTitleFromState = (savedItem, listType) => {
    if (listType === savedListTypes.players.key) {
        return getPlayerName(savedItem.firstName, savedItem.lastName);
    }
    if (listType === savedListTypes.schools.key) {
        return savedItem.name;
    }
    return DEFAULT_TITLE;
};

const getTitleFromQuery = (search, listType) => {
    const parsed = queryString.parse(search);
    const firstName = firstValue(parsed.firstName);
    const lastName = firstValue(parsed.lastName);
    const name = firstValue(parsed.name);
    if (listType === savedListTypes.players.key && (firstName || lastName)) {
        return getPlayerName(firstName, lastName);
    }
    if (listType === savedListTypes.schools.key && name) {
        return name;
    }
    return DEFAULT_TITLE;
};

// The legacy profile header pushes the subject's name as router state; the
// Next.js profile links here with a full page load, so that state is absent
// and the name arrives on the query string instead.
export const getSavedListPageTitle = (location, listType) => {
    if (!location || !listType) {
        return DEFAULT_TITLE;
    }
    if (location.state) {
        return getTitleFromState(location.state, listType);
    }
    return getTitleFromQuery(location.search, listType);
};
